import React from "react";
import { useTranslation } from "react-i18next";
import { Share2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useShareClip } from "@/hooks/use-share-clip";

interface ShareClipButtonProps {
  downloadUrl: string;
  clipName: string;
  className?: string;
  variant?: "icon" | "full";
}

export const ShareClipButton: React.FC<ShareClipButtonProps> = ({
  downloadUrl,
  clipName,
  className = "",
}) => {
  const { t } = useTranslation();
  const { share, isSharing, dialog } = useShareClip({ downloadUrl, clipName });

  const handleShare = (e: React.MouseEvent) => {
    e.stopPropagation();
    void share();
  };

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className={`h-8 w-8 p-0 ${className}`}
            aria-label={t("shareClip.share")}
            disabled={isSharing}
            onClick={handleShare}
          >
            {isSharing ? (
              <Loader2 className="w-3.5 h-3.5 animate-spin" />
            ) : (
              <Share2 className="w-3.5 h-3.5" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom" sideOffset={2}>
          {t("shareClip.share")}
        </TooltipContent>
      </Tooltip>

      {dialog}
    </>
  );
};

export default ShareClipButton;
